import { useCarousel } from "nuka-carousel";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";

const AnnounceSlide = ({ ariaLive = "polite" }) => {
  const { currentPage, totalPages } = useCarousel();

  const t = useFormatMessage();
  const slideDescription = t(intlMessages.slideDescription, {
    index: currentPage + 1,
    total: totalPages
  });

  return (
    <div
      aria-live={ariaLive}
      aria-atomic="true"
      className="slider-slide-announce"
      tabIndex={-1}
    >
      {slideDescription}
    </div>
  );
};

export default AnnounceSlide;

const intlMessages = defineMessages({
  slideDescription: {
    id: "carousel.slideDescription",
    defaultMessage: "{index} sur {total}"
  }
});
